import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faEdit } from '@fortawesome/free-solid-svg-icons'

class ItemList extends React.Component {
    constructor(props){
        super(props);
        this.onClick=this.onClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
    }

    onClick(e) {
        e.preventDefault();
        this.props.handleRemoveClick(e);
    }
    onEditClick(e){
        e.preventDefault();
        this.props.handleEditClick(e);
    }

    render() {
        return(
            <React.Fragment>
                
                <ul className="list-group">
                    {
                        this.props.products.map((product) =>
                        <li key={product.barcode} id={product.barcode} className="list-group-item d-flex  align-items-center">
                            <div  className="fa-left"> <a href="/" onClick={this.onEditClick} ><FontAwesomeIcon icon={faEdit}  size = '2x' color = 'red'/></a></div>
                            {product.name} 
                            <div  className="fa-right"> <a href="/" onClick={this.onClick} ><FontAwesomeIcon icon={faTimes}  size = '2x' color = 'red'/></a></div>
                            <span className="badge bg-primary bg-pill">{product.qty} </span>                        
                        </li>)
                    }
                </ul>
            </React.Fragment>
        )
    }
}

export default ItemList;